import type { Money } from "@core/index";
import { format, abs } from "@core/index";
import { useBrand } from "@branding/useBrand";

/**
 * The tie-out indicator — the product's wedge, surfaced everywhere balances are
 * shown. Green when debits equal credits; red with the exact delta when they
 * don't. It never hides a discrepancy.
 */
export function TieOutBadge({
  tiesOut,
  delta,
  label,
}: {
  tiesOut: boolean;
  delta: Money;
  label?: string;
}) {
  const brand = useBrand();
  if (tiesOut) {
    return (
      <span className="badge good">
        <span className="dot" />
        {label ?? "Balanced"} · Δ 0.00
      </span>
    );
  }
  return (
    <span className="badge bad">
      <span className="dot" />
      Off by Δ {format(abs(delta), brand.locale, { parenNegative: false })}
    </span>
  );
}
